import { memo } from 'react';

import ExpandIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/expand';

import type { I18nService } from '@shared/types/i18n';
import type { UserContext } from '@shared/types/user-context';

import STYLES from './Maps.module.scss';

import { MAP_VIEW } from '@hotels-hotel-detail/utils/location-constants';
import { buildDetailsMapAttributes } from '@hotels-hotel-detail/utils/meaningful-behaviour-data/details-map';
import { HASH_FULL_MAP } from '@shared/constants/hash-routes';
import RouteLink from '@shared/ui/common/RouteLink';
import StaticMaps from '@shared/ui/components/StaticMaps';
import { withI18n } from '@shared/ui/contexts/i18n';
import { MeaningfulBehaviourDataWrapper } from '@shared/ui/contexts/meaningful-behaviour-data';
import { withUserContext } from '@shared/utils-frontend/contexts/UserContext';

type Props = {
  i18n: I18nService;
  trackClick: Function;
  userContext: UserContext;
  isMobile: boolean;
  className: string;
  hotelId: string;
};

// always return true to avoid re-rendering map component
const propsAreEqual = () => true;

const Maps = ({ className, hotelId, i18n, isMobile, trackClick }: Props) => (
  <RouteLink
    href={HASH_FULL_MAP}
    render={(onClick: Function) => (
      <div className={`${STYLES.Map__mapContainer}`}>
        <MeaningfulBehaviourDataWrapper
          {...buildDetailsMapAttributes({ hotelId })}
        >
          <button
            type="button"
            aria-label={i18n.translate('Map_tooltip_expandMap')}
            onClick={(e) => {
              onClick(e);
              trackClick(MAP_VIEW, null);
            }}
            className={`${STYLES.Map__mapButton} ${className}`}
          >
            <StaticMaps hasBorderRadius />
            {!isMobile && (
              <div className={STYLES.Map__expandIconContainer}>
                <ExpandIcon className={STYLES.Map__expandIcon} />
              </div>
            )}
          </button>
        </MeaningfulBehaviourDataWrapper>
      </div>
    )}
  />
);

export default withUserContext(withI18n(memo(Maps, propsAreEqual)));
